exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pageTitle-container {\n  width: 300px;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: no-wrap;\n  align-items: center;\n  justify-content: space-between;\n  margin: 35px 0; }\n\n.rectangle {\n  width: 35px;\n  height: 6px;\n  background-color: \"transparent\"; }\n\n.headerText {\n  font-family: 'Lato-Regular', sans-serif;\n  font-size: 30px;\n  color: var(--title-text-color);\n  width: 100%;\n  text-align: center; }\n\n@media screen and (max-width: 960px) {\n  .pageTitle-container {\n    margin: 20px 0; } }\n", ""]);

// exports
